import { cva } from 'class-variance-authority';

export const cvaPagination = cva(['CatalogCategorySection-cvaPagination', 'flex justify-center', '![list-style:none]']);

export const cvaPaginationPage = cva(
  [
    'CatalogCategorySection-cvaPaginationPage',
    'w-4 sm:w-5.6 h-4 sm:h-5.6',
    'marker:hidden',
    'transition-all duration-300',
    'relative overflow-hidden',
    'before:-z-1 before:pb-[120%] before:absolute before:left-[-10%] before:transform-gpu before:translate-y-[68%] before:scale-0 before:w-[120%] before:h-0 before:rounded-[50%]',
    'after:-z-1 after:absolute after:top-0 after:left-0 after:transform-gpu after:translate-y-[-100%] after:w-full after:h-full after:transition-transform after:ease-button-after after:duration-500',
    'hnotdisable:before:translate-y-0 hnotdisable:before:scale-[1.2] hnotdisable:before:transition-transform hnotdisable:before:duration-400 hnotdisable:before:ease-button-before',
    'hnotdisable:after:translate-y-0 hnotdisable:after:[transition-duration:0.05s] hnotdisable:after:[transition-delay:0.4s] hnotdisable:after:transition-transform hnotdisable:after:ease-button-after',
    'before:bg-cLightGreenBtn after:bg-cLightGreenBtn',
    'rounded-[1.2rem] sm:rounded-[1.6rem]',
  ],
  {
    variants: {
      disabled: {
        true: 'pointer-events-none opacity-[0.64]',
      },
      bg: {
        true: 'bg-[#F2F2FC]',
      },
    },
  }
);

export const cvaPaginationBreak = cva(['CatalogCategorySection-cvaPaginationBreak', 'w-4 sm:w-5.6 h-4 sm:h-5.6']);

export const cvaPaginationBreakLink = cva([
  'CatalogCategorySection-cvaPaginationBreakLink',
  'flex items-center justify-center',
  'w-full h-full',
  'text-bodyM text-cBlack text-opacity-[0.48]',
  'rounded-[1.2rem] sm:rounded-[1.6rem]',
]);

export const cvaPaginationLink = cva([
  'CatalogCategorySection-cvaPaginationLink',
  'marker:hidden',
  'flex items-center justify-center',
  'w-full h-full',
  'text-bodyM text-cBlack text-opacity-[0.48]',
  'rounded-[1.2rem] sm:rounded-[1.6rem]',
  'relative z-10',
]);

export const cvaPaginationArrow = cva(['CatalogCategorySection-cvaPaginationArrow', 'text-cBlack'], {
  variants: {
    disabled: {
      true: 'opacity-[0.64] pointer-events-none',
    },
  },
});

export const cvaPaginationLinkActive = cva([
  'CatalogCategorySection-cvaPaginationLinkActive',
  'bg-cMediumGreyOnWhite',
  '!text-cBlack !text-opacity-100',
  'pointer-events-none cursor-default',
]);

export const cvaArrowIcon = cva(['CatalogCategorySection-cvaArrowIcon', 'w-1.6 h-1.6 z-50'], {
  variants: {
    direction: {
      prev: 'rotate-180',
      next: '',
    },
  },
});
